<div class="generic-list-paginator" *ngIf="paginationEnabled && paginationLocation === 'top'">
  <mat-paginator
    #genericListPaginator
    (page)="pageGenericList($event)"
    [class.hide-default-range-label]="showPaginationLength"
    [length]="paginationLength"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="pageSizeOptions"
  >
  </mat-paginator>
  <span class="pagination-range-label" *ngIf="showPaginationLength">{{ getPaginationRangeLabel() }}</span>
</div>

<ng-container>
  <app-filter
    *ngIf="filtersEnabled"
    [title]="filtersTitle"
    [filters]="filters"
    (filtersChangedHandler)="filtersChanged($event)"
  ></app-filter>
  <mat-progress-bar [mode]="'indeterminate'" #loadingSpinner class="list-loading-spinner" *ngIf="shouldShowLoader"></mat-progress-bar>
  <div>
    <mat-table #table [dataSource]="dataSource">
      <ng-container *ngFor="let column of columns; let last = last" matColumnDef="{{ column.columnDef }}">
        <mat-header-cell id="genericList-headerCell-{{ column.title | camelCase }}" *matHeaderCellDef>{{ column.title }}</mat-header-cell>
        <mat-cell
          *matCellDef="let dataItem; let index = index"
          [ngClass]="{ fit: isIconButtonCell(column.cell(dataItem)) }"
          matTooltip="{{ column.tooltip ? column.tooltip(dataItem) : null }}"
          [matTooltipPosition]="'after'"
          [matTooltipShowDelay]="0"
          [matTooltipHideDelay]="0"
        >
          <app-generic-list-button
            [testingId]="idx(testingIdAccessor, dataItem)?.toString() | camelCase"
            (click)="$event.stopPropagation()"
            *ngIf="isButtonCell(column.cell(dataItem))"
            [data]="column.cell(dataItem)['data']"
            [clickHandler]="column.cell(dataItem)['clickHandler']"
            [buttonTitle]="column.cell(dataItem)['buttonTitle']"
            [buttonColor]="column.cell(dataItem)['buttonColor']"
            [disabled]="column.cell(dataItem)['disabled']"
          >
          </app-generic-list-button>

          <app-generic-list-link
            [testingId]="idx(testingIdAccessor, dataItem)?.toString() | camelCase"
            (click)="$event.stopPropagation()"
            *ngIf="isLinkCell(column.cell(dataItem))"
            [data]="column.cell(dataItem)['data']"
            [clickHandler]="column.cell(dataItem)['clickHandler']"
            [linkTitle]="column.cell(dataItem)['linkTitle']"
          >
          </app-generic-list-link>

          <app-generic-list-icon-button
            [testingId]="idx(testingIdAccessor, dataItem)?.toString() | camelCase"
            (click)="$event.stopPropagation()"
            *ngIf="isIconButtonCell(column.cell(dataItem))"
            [data]="column.cell(dataItem)['data']"
            [clickHandler]="column.cell(dataItem)['clickHandler']"
            [icon]="column.cell(dataItem)['icon']"
            [buttonColor]="column.cell(dataItem)['buttonColor']"
            [disabled]="column.cell(dataItem)['disabled']"
          >
          </app-generic-list-icon-button>

          <app-generic-list-icon
            *ngIf="isIconCell(column.cell(dataItem)) && column.cell(dataItem)['icon']"
            [icon]="column.cell(dataItem)['icon']"
          >
          </app-generic-list-icon>
          <app-generic-list-slide-toggle
            (click)="$event.stopPropagation()"
            *ngIf="isSlideToggleCell(column.cell(dataItem))"
            [label]="column.cell(dataItem)['label']"
            [classes]="column.cell(dataItem)['classes']"
            [clickHandler]="column.cell(dataItem)['clickHandler']"
            [data]="column.cell(dataItem)['data']"
            [state]="column.cell(dataItem)['state']"
            [disabled]="column.cell(dataItem)['disabled']"
            [color]="column.cell(dataItem)['color']"
          >
          </app-generic-list-slide-toggle>
          <app-generic-list-select
            [testingId]="idx(testingIdAccessor, dataItem)?.toString()"
            *ngIf="isSelectCell(column.cell(dataItem))"
            [data]="column.cell(dataItem)['data']"
            [value]="column.cell(dataItem)['value']"
            [choices]="column.cell(dataItem)['choices']"
            [clickHandler]="column.cell(dataItem)['clickHandler']"
            [disabled]="column.cell(dataItem)['disabled']"
          >
          </app-generic-list-select>
          <app-generic-list-menu
            [testingId]="idx(testingIdAccessor, dataItem)?.toString()"
            *ngIf="isMenuCell(column.cell(dataItem))"
            [data]="column.cell(dataItem)['data']"
            [label]="menuButtonLabel"
            [choices]="column.cell(dataItem)['choices']"
            [clickHandler]="column.cell(dataItem)['clickHandler']"
            [disabled]="column.cell(dataItem)['disabled']"
          >
          </app-generic-list-menu>
          <app-generic-list-input *ngIf="isInputCell(column.cell(dataItem))" [data]="column.cell(dataItem)['data']">
            [type]="column.cell(dataItem)['type']"> [controlName]="column.cell(dataItem)['controlName']">
            [suffix]="column.cell(dataItem)['suffix']">
          </app-generic-list-input>
          <span *ngIf="isHtmlCell(column.cell(dataItem))" [innerHtml]="column.cell(dataItem) | safeHtml"></span>
        </mat-cell>
      </ng-container>
      <mat-header-row id="genericList-header-headerRow" *matHeaderRowDef="displayedColumns; sticky: fixedHeader"></mat-header-row>
      <!-- prettier-ignore -->
      <mat-row
        *matRowDef="let row; columns: displayedColumns; let index = index"
        id="genericList-matRow-{{ idx(testingIdAccessor, row)?.toString() | camelCase }}"
        [ngClass]="{
          'striped': striped && index % 2 == 1,
          'selectable': allowsSelection,
          'inactive': enableInactiveShading && row.hasOwnProperty('active') && !row.active,
          'selected': enableSelectedShading && row.hasOwnProperty('selected') && row.selected,
          'en-route': enableStatusColors && row.status === reservationStatuses.DRIVER_EN_ROUTE,
          'pick-up-arrived': enableStatusColors && row.status === reservationStatuses.PICK_UP_ARRIVED,
          'drop-off-arrived': enableStatusColors && row.status === reservationStatuses.DROP_OFF_ARRIVED,
          'in-progress': enableStatusColors && row.status === reservationStatuses.IN_PROGRESS,
          'cancelled': enableStatusColors && row.status === reservationStatuses.CANCELLED,
          'priority-0': enablePriorityColors && row.operationsAlertType.priority === 0,
          'priority-1': enablePriorityColors && row.operationsAlertType.priority === 1,
          'random-screening-result-alert': enableStatusColors && row.result ===  'alert',
          'random-screening-result-review': enableStatusColors && row.result ===  'review'
        }"
        (click)="rowClicked(row)"
      >
      </mat-row>
    </mat-table>
  </div>
</ng-container>

<div class="generic-list-paginator" *ngIf="paginationEnabled && paginationLocation === 'bottom'">
  <mat-paginator
    #genericListPaginator
    (page)="pageGenericList($event)"
    [class.hide-default-range-label]="showPaginationLength"
    [length]="paginationLength"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="pageSizeOptions"
  >
  </mat-paginator>
  <span class="pagination-range-label" *ngIf="showPaginationLength">{{ getPaginationRangeLabel() }}</span>
</div>
